/** Mirrors the server's `CommentReplyRequestValidator`: a reply to a comment is refused beyond this many characters. */
export const COMMENT_REPLY_MAX_LENGTH = 2000;

/** The share of the limit from which the field counts the characters typed, so the count only shows when it helps. */
export const COMMENT_REPLY_COUNTER_FROM = 0.9;
